export default __webpack_public_path__ + "static/media/l-3.cd702bee.png";